import {auth} from 'firebase'
import Vue from 'vue'
import axios from '../../axios'
import router from '../../router'
import store from "../store";

export var creating = {
  state: {
    mapOpacity: 0.66,
    isMaximised: false,
    preventNext: false,
    temp: {
      description: '',
      qid: 'new',
      linked_id: '',
      endpoint: '',
      startpoint: '',
      routes: [],
      comments: []
    },
  },
  mutations: {
    PREVENT_NEXT (state, payload) {
      state.preventNext = payload;
    },
    TOGGLE_MAXIMISED (state){
      state.isMaximised = !state.isMaximised
    },
    RESET_TEMP_QUESTION(state, payload) {
      var tempObj = {
        description: '',
        qid: 'new',
        linked_id: '',
        endpoint: '',
        startpoint: '',
        routes: [],
        comments: [],
        startPointStyle: [],
        endPointStyle: []
      };
      Vue.set(state, 'temp', tempObj)
    },
    SET_QUESTIONMARK_ID(state, payload) {
      state.temp.linked_id = payload;
    },
    UPDATE_QUESTION_ID(state, payload) {
      state.temp.qid = payload;
    },
    UPDATE_QUESTION_DESCRIPTION(state, payload) {
      state.temp.description = payload;
    },
    SET_WORKING_QUESTION(state, payload) {
      payload.isEdit = true; //flag existing questions
      state.temp = payload;
    },
    setCreatorMapOpacity(state, payload) {
      state.mapOpacity = payload
    },
    cancelNewQuestion(state) {
      // clear temp item
      state.temp = {};
      // remove last question from array if it has a status of 'new'
      var lastobj = state.questions.length - 1;
      console.log('cancelNewQuestion - lastobj = ' + lastobj);
      if (state.questions[lastobj].status == 'new') {
        state.questions.pop();
      }
    },
    addQuestionStartpoint(state, value) {
      Vue.set(state.temp, 'startpoint', value)
    },
    addQuestionEndpoint(state, value) {
      // add/replace endpoint in temp object - only add if there is a new question existing
      if (state.temp.qid) {
        state.temp.endpoint = value
      }
    },
    CREATOR_CLEAR_ROUTES(state) {
      state.temp.routes = [];
    },
    CREATOR_CLEAR_COMMENTS(state) {
      state.temp.comments = [];
    },
    CREATOR_REMOVE_ROUTE(state, idnr) {
      for (var route in state.temp.routes) {
        if (state.temp.routes[route].idnr.toString() === idnr.toString()) {
          state.temp.routes.splice(route, 1);
          return;
        }
      }
    },
    CREATOR_REMOVE_COMMENT(state, idnr) {
      for (var comment in state.temp.comments) {
        if (state.temp.comments[comment].idnr === idnr) {
          state.temp.comments.splice(comment, 1);
          return;
        }
      }
    },
    CREATOR_ADD_ROUTE(state, payload) {
      state.temp.routes.push(payload)
    },
    CREATOR_ADD_COMMENT(state, payload) {
      for (var comment in state.temp.comments) {
        if (state.temp.comments[comment].idnr === payload.idnr) {
          state.temp.comments.splice(comment, 1);
          state.temp.comments.splice(comment, 0, payload);
          return;
        }
      }

      state.temp.comments.push(payload);
    },
    addQuestionRoutes(state, value) {
      // add/replace routes in temp object - only add if there is a new question existing
      if (state.temp.qid) {
        var routeIDNR = value.idnr;
        for (var route in state.temp.routes) {
          if (state.temp.routes[route].idnr === routeIDNR) {
            for (let key in value) {
              if (key === 'idnr')
                continue;
              state.temp.routes[route][key] = value[key]
            }
            return;
          }
        }

        //state.temp.routes.push(value)
      }
    },
  },
  actions: {
    CANCEL_CREATE({commit, state, dispatch}, payload) {
      console.log("CANCEL CREATE");
      if (!state.temp.isEdit) {
        dispatch('DELETE_QUESTION');
      }
      commit('SET_TASK', '');
      commit('RESET_TEMP_QUESTION');
      router.push('/');
    },
    SAVE_QUESTION({commit, dispatch}, payload) {
      return new Promise((resolve, reject) => {

        auth().currentUser.getIdToken(true).then((idToken) => {
          commit('auth/SET_FIREBASE_TOKEN', idToken);
          axios.defaults.headers.common['tat-token'] = idToken;
          axios.post('/savequestion?' + Math.random(), {
            params: payload
          }).then((response) => {
            dispatch('fetchQuestions');
            resolve(response);
          }).catch((err) => {
            reject(err)
          })
        })
      });
    },
    DELETE_QUESTION({commit, dispatch, rootGetters}, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/deletequestion', {
          params: {qid: rootGetters.getNewQuestion.qid}
        }).then((response) => {
          dispatch('fetchQuestions');
          resolve();
        })
      })
    },
    UPDATE_QUESTIONMARK_ID({commit, dispatch, rootGetters}, payload) {
      commit('SET_QUESTIONMARK_ID', payload)
      dispatch('SAVE_QUESTION', rootGetters.getNewQuestion)
    },
    ADD_QUESTION({state, commit}, payload) {
      state.temp = payload
      //state.temp.startpoint = 'new startpoint created';
      // add (incomplete) to qid , status'new' and push to min questions list
      // create newobj to avoid payload being mutated into temp object

      //commit('storeNewQuestion', payload);
    }
  },
  getters: {
    IS_MAXIMISED (state) {
      return state.isMaximised;
    },
    PREVENT_NEXT (state) {
      return state.preventNext;
    },
    getNewQuestion(state) {
      return state.temp;
    },
    getRoutes(state) {
      return state.temp.routes;
    },
    getStartpoint(state) {
      return state.temp.startpoint;
    },
    getEndpoint(state) {
      return state.temp.endpoint;
    },
    getStartPointStyle(state) {
      return state.temp.startPointStyle;
    },
    getEndPointStyle(state) {
      return state.temp.endPointStyle;
    },
    getCreatorMapOpacity(state) {
      return state.mapOpacity
    },
    getComments(state) {
      return state.temp.comments;
    }
  }
};


